import React from "react";
import PropTypes from "prop-types";
import "./loadingAnimation.scss";

function LoadingAnimation(props) {
  if (props.uiLoader) {
    return (
      <div className="lds-ellipsis">
        <div />
        <div />
        <div />
        <div />
      </div>
    );
  }

  return (
    <div
      className={`md-cs-loader ${props.customStyle} loading__animation flex flex-col items-center`}
      style={{ height: props.height || "100%" }}
    >
      <div className="md-cs-loader-inner">
        <div className="stairs-up-loader">
          <div className="stairs-up-loader__bar" />
          <div className="stairs-up-loader__bar" />
          <div className="stairs-up-loader__bar" />
          <div className="stairs-up-loader__bar" />
          <div className="stairs-up-loader__bar" />
          <div className="stairs-up-loader__ball" />
        </div>
        <p>{props.text ? props.text : "Loading..."}</p>
      </div>
    </div>
  );
}

LoadingAnimation.propTypes = {
  customStyle: PropTypes.string,
  uiLoader: PropTypes.bool,
  text: PropTypes.string,
  height: PropTypes.any
};

LoadingAnimation.defaultProps = {
  uiLoader: false,
  customStyle: ""
};

export default LoadingAnimation;
